import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'enauka-home-zeszyt',
  templateUrl: './home-zeszyt.component.html',
  styleUrls: ['./home-zeszyt.component.css']
})
export class HomeZeszytComponent implements OnInit {
  images = [
    '/shared-assets/images/zeszyt/screen-9.jpg',
    '/shared-assets/images/zeszyt/screen-7a.jpg',
    '/shared-assets/images/zeszyt/screen-5a.jpg',
    '/shared-assets/images/zeszyt/screen-4a.jpg',
    '/shared-assets/images/zeszyt/screen-8.jpg'
  ];

  opinions = [
    {
      source: 'Szkoła Podstawowa nr 169 - Warszawa',
      opinion: 'Mam bardzo słabą uczennicę. Rodzice znając awersję córki do nauki cieszą się,\n' +
        'że w miarę chętnie i systematycznie rozwiązuje zadania z systemu. Nie zniechęca się.'
    },
    {
      source: 'Szkoła Podstawowa nr 50 - Warszawa (Praga Północ)',
      opinion: 'Widzę, że system pomaga. Dzieci zaczęły się przełamywać i chodzić do tablicy.'
    },
    {
      source: 'Szkoła Podstawowa nr 61 - Warszawa (Ochota)',
      opinion: 'Nawet słabsze dzieci były zadowolone. Dzieci czują, że system im pomaga.'
    },
    {
      source: 'Szkoła Podstawowa nr 319 - Warszawa (Ursynów)',
      opinion: 'Mam wrażenie, że już po miesiącu używania część dzieci zaczęło sobie lepiej radzić z matematyką.'
    },
    {
      source: 'Szkoła Podstawowa nr 358 - Warszawa (Ochota)',
      opinion: 'Mam wiele uwag od dzieci, że pomoc im pomaga, gdy mają problem z zadaniem.'
    },
    {
      source: 'Szkoła Podstawowa nr 16 - Warszawa (Ursynów)',
      opinion: 'Bardzo byśmy chcieli używać tego w przyszłym roku. Nam to bardzo pomaga.'
    },
    {
      source: 'WOW - Warszawa (Bemowo)',
      opinion: 'Projektem jestem zachwycona. Zauważyłam wzrost umiejętności matematycznych w klasie \n' +
        'testującej projekt, względem innych klas, które uczę.'
    },
    {
      source: 'Szkoła Podstawowa nr 307 - Warszawa (Mokotów)',
      opinion: 'Dzieci są zadowolone. Poziom zadań jest dla nich dopasowany.\n' +
        'Rodzice mówią, że to rewelacyjna platforma.'
    },
    {
      source: 'Szkoła Podstawowa nr 216 - Warszawa (Wawer)',
      opinion: 'Słabi uczniowie cieszyli się z otrzymanej pomocy.\n' +
        'Dla dobrych zadania były rozwijające i jednocześnie atrakcyjne.'
    },
    {
      source: 'Szkoła Podstawowa nr 189 - Warszawa (Rembertów)',
      opinion: 'Najlepsi uczniowie są zafascynowani tą nauką. Mam chłopca, który żyje tym systemem.'
    },
    {
      source: 'Szkoła Podstawowa nr 212 - Warszawa (Mokotów)',
      opinion: 'Mam ucznia, który nie robi obowiązkowych papierowych prac domowych, \n' +
        'a robi wszystkie (nieobowiązkowe) zadania w systemie.'
    },
    {
      source: 'Szkoła Podstawowa nr 169 - Warszawa (Wilanów)',
      opinion: 'Mam bardzo słabą uczennicę. Rodzice znając awersję córki do nauki cieszą się, \n' +
        'że w miarę chętnie i systematycznie rozwiązuje zadania z systemu. Nie zniechęca się.'
    },
    {
      source: 'Szkoła Podstawowa nr 368 - Warszawa (Białołęka)',
      opinion: 'Dzieci się cieszą z używania tego systemu. Zdobywają tytuły. Rozmawiają o tym.'
    },
    {
      source: 'WOW - Warszawa (Bemowo)',
      opinion: 'Dzieci podeszły z wielkim entuzjazmem do projektu i cały czas wykazują zainteresowanie. \n' +
        'Zadania są dostosowane do poziomu uczniów. Dzieci liczą na kontynuację w klasie piątej.'
    },
    {
      source: 'Szkoła Podstawowa nr 189 - Warszawa (Rembertów)',
      opinion: 'Najlepsi uczniowie są zafascynowani tą nauką. Mam chłopca, który żyje tym systemem.'
    },
    {
      source: 'Szkoła Podstawowa nr 3 - Biłgoraj',
      opinion: 'Bardzo pomocne narzędzie pracy :)'
    },
    {
      source: 'Zespół Szkolno-Przedszkolny w Korczynie',
      opinion: 'Bardzo pomocny zwłaszcza podczas kształcenia na odległość. Możliwość powtórzenia i \n'
        + 'utrwalenia wiadomości i umiejętności, super alternatywa dla tradycyjnych zadań domowych.'
    },
    {
      source: 'Szkoła Podstawowa nr 4 - Skierniewice',
      opinion: 'Bardzo ciekawe narzędzie. Uczniowie bardzo je polubili.'
    },
    {
      source: 'Szkoła Podstawowa nr 1 - Myślenice',
      opinion: 'Bardzo pomocne narzędzie w pracy nauczyciela. Zdecydowanym plusem jest to, \n' +
        'iż uczeń osiągający sukces jest bardziej zmotywowany do dalszej pracy.'
    },
    {
      source: 'Szkoła Podstawowa nr 7 - Stalowa Wola',
      opinion: 'Rewelacja. Bardzo pomogły w zdalnym nauczaniu, uczniowie chętnie pracowali.'
    },
    {
      source: 'Szkoła Podstawowa nr 27 - Rzeszów',
      opinion: 'Bardzo dobre narzędzie, zachwalane przez nauczycieli, uczniów i rodziców.'
    },
    {
      source: 'Szkoła Podstawowa nr 6 - Żywiec',
      opinion: 'Bardzo dobry pomysł na taki system, zwłaszcza podczas zdalnego nauczania. \n' +
        'Uczniowie, którzy chcieli ćwiczyć poznane umiejętności matematyczne mogli to robić \n' +
        'samodzielnie - dodatkowa nauka. Sprawdziany - dodatkowe narzędzie dla nauczyciela.'
    },
    {
      source: 'Szkoła Podstawowa nr 6 - Słupsk',
      opinion: 'Bardzo ciekawe narzędzie, świetnie przydało się w czasie zadlnej nauki.'
    },
    {
      source: 'Szkoła Podstawowa nr 14 - Krosno',
      opinion: 'Mnie i moim uczniom system zeszyt.online bardzo przypadł do gustu, doskonała \n' +
        'forma powtórek, ćwiczeń, doskonalenia swoich umiejętności, wdrażania uczniów do samodzielnej \n' +
        'pracy, wytrwałości w dążeniu do celu.'
    },
    {
      source: 'Szkoła Podstawowa nr 1 - Ełk',
      opinion: 'Ciekawa forma utrwalenia i powtórzenia materiału. Uczeń uczy się na błędach i może osiągnąć \n' +
        'sukces. Mało pracy dla nauczyciela i szybki wgląd w prace i postępy uczniów. Uatrakcyjnienie zajęć \n' +
        'stacjonarnych i atrakcyjna praca domowa.'
    },
    {
      source: 'Szkoła Podstawowa nr 3 - Stargard',
      opinion: 'Bardzo dobre narzędzie do nauki matematyki. Uczniowie zadowoleni. Wielu z nich chętnie \n' +
        'rozwiązywało zadania. Niektórzy poprosili nawet o zadania na wakacje.'
    },
    {
      source: 'Szkoła Podstawowa - Krynica Morska',
      opinion: 'Program bardzo pomocny, indywidualizacja zadań, bogaty w treści, bardzo wciągający, podobał \n' +
        'się dzieciom, nie pozostawił dzieci samym sobie podczas niepowodzenia, \n' +
        'naprowadzał do poprawnego rozwiązania zadań, nauczał, bawił.'
    },
    {
      source: 'Szkoła Podstawowa nr 5 - Stalowa Wola',
      opinion: 'Jesteśmy bardzo zadowoleni z programu. Ułatwił pracę na zdalnym nauczaniu, pozwalał utrwalać \n' +
        'wiadomości i pomógł w przedstawianiu geometrii. uczniowie bardzo chętnie rozwiązywali zadania w programie zeszyt.online.'
    },
    {
      source: 'Szkoła Podstawowa nr 1 - Nowy Targ',
      opinion: 'Bardzo dobre wsparcie nauczyciela, ciekawe interaktywne zadania, duży wybór zadań co umożliwia \n' +
        'dostosowanie zadań do możliwości każdego ucznia.'
    },
    {
      source: 'Szkoła Podstawowa nr 6 - Szczecinek',
      opinion: 'Bardzo fajnie i przydatne narzędzie utrwalajace.'
    },
    {
      source: 'Szkoła Podstawowa nr 1 - Wałbrzych',
      opinion: 'W ankiecie na koniec roku uczniowie wyrazili swoją opinię na temat wykonywanych zadań. Okazało się, \n' +
        'że chociaż dla większości uczniów matematyka jest trudna, to jednak zadania na zeszyt.online \n' +
        'rozwiązywali chętnie i dawało to im satysfakcję. System zeszyt.online jest pomocny w pracy podczas lekcji, dodatkowych zajęć.'
    },
    {
      source: 'Szkoła Podstawowa nr 45 - Białystok',
      opinion: 'Zadania były ciekawe, uczniowie (oczywiście nie wszyscy) rozwiązywali je w miarę systematycznie i chętnie. \n' +
        'Była grupa uczniów, którzy dopominali się o kolejną porcję zadań.'
    },
    {
      source: 'Szkoła Podstawowa nr 10 - Tychy',
      opinion: 'Ciekawy i pomocny jako uzupełniający system aktywacji uczniów.'
    },
    {
      source: 'Szkoła Podstawowa nr 2 - Świebodzin',
      opinion: 'Jestem bardzo zadowolona z pracy z zeszytami online, moi uczniowie również. Wykorzystywałam je jako zadania domowe, \n' +
        'samodzielna prace na lekcji lub sprawdziany . Chętnie będę pracować w przyszłym roku szkolnym.'
    },
    {
      source: 'Szkoła Podstawowa nr 3 - Żyrardów',
      opinion: 'Uczniowie z dużym zaangażowaniem rozwiazywali zadania i na pewno z chęcia przystapią do projektu w przyszłym roku szkolnym.'
    },
    {
      source: 'Szkoła Podstawowa nr 3 - Żary',
      opinion: 'Świetne narzędzie do pracy z uczniami na różnych poziomach umiejętności. Nie sądziłam, że będzie aż tak pomocne - szczególnie \n' +
        ' w okresie nauki zdalnej. Chętnie podejmę się kontynuacji w następnym roku szkolnym.'
    }
  ];

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  openOpinion() {
    this.router.navigate(['/opinie']);
  }

}
